import { APICliqueiAchei } from '@app/services/cliqueiachei-api';
import { promise } from '@app/utils/development';
import { delay } from '@app/utils/timers';
import { addMilliseconds } from 'date-fns';
import React, { ReactNode, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';

export interface Clock {
  now: () => Date | null;
}

const ClockContext = React.createContext({} as Clock);

type Props = {
  children: ReactNode;
};

export default function ClockContextProvider({ children }: Props) {
  const [serverSideTime, setServerSideTime] = useState<Date | null>(null);

  const lastUpdatedServerSideTime = useRef<number>(0);

  useEffect(() => {
    async function loadTimeFromServer() {
      try {
        const requestStartTime = Date.now();
        // await promise(1, { shouldReject: true, rejectResponse: { message: 'Fake error' } });
        const serverTime = await APICliqueiAchei.fetchTime();
        const requestEndTime = Date.now();
        const requestTime = requestEndTime - requestStartTime;
        console.log('\nServer side time request has completed: ', serverTime.toLocaleString());
        console.log('Request time: ', requestTime);
        setServerSideTime(addMilliseconds(serverTime, requestTime));
        lastUpdatedServerSideTime.current = Date.now();
      } catch (error: any) {
        console.log('Error when getting server time: ', error.message);
        await delay(1);
        loadTimeFromServer();
      }
    }
    loadTimeFromServer();
  }, []);

  const now = useCallback(() => {
    if (!serverSideTime) {
      console.log('Server side time not available');
      return null;
    }

    const serverSideTimeInMilli = serverSideTime.getTime();
    const milliEverSinceUpdateServerTime =
      lastUpdatedServerSideTime.current === 0 ? 0 : Date.now() - lastUpdatedServerSideTime.current;

    const nowTimeInMilli = serverSideTimeInMilli + milliEverSinceUpdateServerTime;

    return new Date(nowTimeInMilli);
  }, [serverSideTime]);

  return <ClockContext.Provider value={{ now }}>{children}</ClockContext.Provider>;
}

export function useClock() {
  return useContext(ClockContext);
}
